// XSS-safe HTML escape — all dynamic content MUST pass through esc() before innerHTML
const _escDiv = document.createElement('div');
export function esc(str: any): string {
  if (str == null) return '';
  _escDiv.textContent = String(str);
  return _escDiv.innerHTML;
}

// Safe innerHTML setter — only used with pre-escaped content via esc()
export function setHTML(el: string | Element | null, html: string) {
  if (typeof el === 'string') el = document.querySelector(el);
  if (el) el.innerHTML = html;  // SAFE: all dynamic values pre-escaped via esc()
}

export const $ = (sel: string, ctx?: Element | Document): Element | null =>
  (ctx || document).querySelector(sel);

export const $$ = (sel: string, ctx?: Element | Document): NodeListOf<Element> =>
  (ctx || document).querySelectorAll(sel);

export function formatDate(d: string | null | undefined): string {
  if (!d) return '\u2014';
  return new Date(d).toLocaleDateString('en-US', { year: 'numeric', month: 'short', day: 'numeric' });
}

export function formatCurrency(amount: number | null | undefined, currency?: string): string {
  if (amount == null) return '\u2014';
  return new Intl.NumberFormat('en-US', { style: 'currency', currency: currency || 'USD' }).format(amount);
}

export function statusBadge(status: string | null | undefined): string {
  if (!status) return '';
  const label = status.replace(/_/g, ' ').replace(/\b\w/g, c => c.toUpperCase());
  // esc() ensures status and label are safe for innerHTML
  return `<span class="status status-${esc(status)}"><span class="status-dot"></span>${esc(label)}</span>`;
}

export function timeAgo(date: string | null | undefined): string {
  if (!date) return '';
  const diff = Date.now() - new Date(date).getTime();
  const mins = Math.floor(diff / 60000);
  if (mins < 1) return 'just now';
  if (mins < 60) return mins + 'm ago';
  const hours = Math.floor(mins / 60);
  if (hours < 24) return hours + 'h ago';
  const days = Math.floor(hours / 24);
  if (days < 30) return days + 'd ago';
  return formatDate(date);
}

export function greeting(): string {
  const h = new Date().getHours();
  if (h < 12) return 'Good morning';
  if (h < 18) return 'Good afternoon';
  return 'Good evening';
}

export function icons() {
  if ((window as any).lucide) (window as any).lucide.createIcons({ nameAttr: 'data-lucide', attrs: {} });
}
